var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "-38.4 -38.4 268.80 268.80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-38.4, -38.4), scale(16.8)",
    fill: "#ffffff",
    d: "M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M170 96h6a6 6 0 0 0-6-6v6Zm-21.674-52.326 4.243 4.243a6 6 0 0 0 0-8.485l-4.243 4.242ZM96 90a6 6 0 0 0 0 12V90Zm26.87-20.87-4.243 4.243a6.003 6.003 0 0 0 8.486 0l-4.243-4.243ZM164 96a68.003 68.003 0 0 1-15.435 43.139l9.276 7.613A80.005 80.005 0 0 0 176 96h-12Zm-15.435 43.139a68.008 68.008 0 0 1-39.299 23.555l2.341 11.769a80.003 80.003 0 0 0 46.234-27.711l-9.276-7.613Zm-39.299 23.555a68.002 68.002 0 0 1-45.321-6.723l-5.657 10.583a79.997 79.997 0 0 0 53.319 7.909l-2.341-11.769Zm-45.321-6.723a68.002 68.002 0 0 1-30.769-33.948l-11.086 4.592a80.002 80.002 0 0 0 36.198 39.939l5.657-10.583Zm-30.769-33.948a68.001 68.001 0 0 1-2.248-45.762l-11.483-3.484a80 80 0 0 0 2.645 53.838l11.086-4.592Zm-2.248-45.762a68 68 0 0 1 27.293-36.8l-6.667-9.978a80 80 0 0 0-32.11 43.294l11.484 3.484Zm27.293-36.8a68 68 0 0 1 44.444-11.133l1.176-11.943a80 80 0 0 0-52.287 13.098l6.667 9.977Zm44.444-11.133a67.997 67.997 0 0 1 41.418 19.589l8.486-8.485a80.002 80.002 0 0 0-48.728-23.047l-1.176 11.943ZM170 90H96v12h74V90Zm-42 6c0 17.673-14.327 32-32 32v12c24.301 0 44-19.699 44-44h-12Zm-32 32c-17.673 0-32-14.327-32-32H52c0 24.301 19.7 44 44 44v-12ZM64 96c0-17.673 14.327-32 32-32V52c-24.3 0-44 19.7-44 44h12Zm32-32c8.838 0 16.83 3.575 22.627 9.373l8.486-8.486C119.157 56.932 108.149 52 96 52v12Zm48.083-24.568-25.456 25.455 8.486 8.486 25.456-25.456-8.486-8.485Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 40,
    r: 6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 152,
    r: 6,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.402,
    cy: 56.402,
    r: 6,
    fill: "#000000",
    transform: "rotate(-45 56.402 56.402)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 96,
    r: 6,
    fill: "#000000",
    transform: "rotate(-90 40 96)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.598,
    cy: 135.598,
    r: 6,
    fill: "#000000",
    transform: "rotate(-45 135.598 135.598)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.402,
    cy: 135.598,
    r: 6,
    fill: "#000000",
    transform: "rotate(-135 56.402 135.598)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuth);
export default __webpack_public_path__ + "static/media/google-auth.7c2df3d3c7aa3c9cd393ad38a4d7411f.svg";
export { ForwardRef as ReactComponent };